import { storeToRefs } from 'pinia';
import mainStore from '@/stores/main-store';

const useMainStore = () => {
    const { accessToken, oid, attributeStoreData, userId, username, loginType, roles, tokenShouldBeRefreshed, partnerParcelNumberTypes } =
        storeToRefs(mainStore());

    return {
        accessToken,
        oid,
        attributeStoreData,
        username,
        userId,
        loginType,
        roles,
        tokenShouldBeRefreshed,
        partnerParcelNumberTypes
    };
};

export default useMainStore;
